import React from "react";

function Button({
  label,
  variant = "outline",
  size = "medium",
  fullWidth = false,
  ...otherprops
}) {
  // Variant styles
  const variantStyles = {
    primary:
      "bg-[#002368] text-white hover:bg-[#ff5003] border-[#002368] hover:border-[#ff5003]",
    secondary:
      "bg-[#ff5003] text-white hover:bg-[#002368] border-[#ff5003] hover:border-[#002368]",
    outline:
      "bg-white text-[#002368] hover:bg-[#002368] hover:text-white border-[#002368] hover:border-[#002368]",
    ghost: "bg-transparent text-[#002368] hover:bg-gray-100 border-transparent",
  };

  // Size styles
  const sizeStyles = {
    small: "py-1 px-3 text-xs",
    medium: "py-2 px-4 text-sm",
    large: "py-2.5 px-5 text-base",
  };

  return (
    <button
      className={`
        ${variantStyles[variant]}
        ${sizeStyles[size]}
        ${fullWidth ? "w-full" : "w-fit"}
        rounded-lg border transition-all duration-200 flex items-center justify-center
        disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:border-gray-300
        focus:outline-none focus:ring-2 focus:ring-[#002368]/30
      `}
      {...otherprops}
    >
      {label}
    </button>
  );
}

export default Button;
